import { Injectable, Optional, Inject, EventEmitter, RESPONSE_INIT } from '@angular/core';
import { PlatformInformationService } from '../../../../projects/platform-manager/src/public_api';

@Injectable({
  providedIn: 'root'
})
export class ResponseService {
  readonly notFoundEvent: EventEmitter<null> = new EventEmitter<null>();

  constructor(
    private platformService: PlatformInformationService,
    @Optional() @Inject(RESPONSE_INIT) private res: ResponseInit
  ) {}

  setResponseCode(code: number) {
    if (!this.platformService.getIsBrowser()) {
      this.res.status = code;
    }
  }

  show404Page() {
    this.setResponseCode(404);
    this.notFoundEvent.emit();
  }
}
